import { LANGUAGES } from "./languages.c";

export const URL_LANGUAGE = window.location.pathname.split("/")[1] === LANGUAGES.JP ? LANGUAGES.JP : LANGUAGES.EN
 